<div class="notification-dialog-container">
  <p class="title">{{data.title}}</p>
  <p class="message">{{data.message}}</p>
  <div class="actions">
    <button (click)="closeAction(true)" mat-raised-button class="accept"><span>Aceitar</span></button>
  </div>
</div>
